import { Link } from "react-router-dom"
import { getUrlListA } from "./Url"
import { GoStack } from "react-icons/go";
import styles from './PresenterPage.module.css'
import { useLanguage } from '../contexts/LanguageContext'
import getData from './Model'

// Представление страницы, встраивается в SingleViewer
function PresenterPage({page_title, page_content, language}){
    const ui = getData('ui', language)
    
    // Вернем фрагменты
    return (
        <>
            <h1 className={styles.page_title}>{page_title}</h1>
            <div className={styles.page_content}>{page_content}</div>
            <Link to={getUrlListA('page')} title={ui.pages}>
                <GoStack /> {ui.pages}
            </Link>
        </>
    )
}

export default PresenterPage